import _ from 'lodash';
import { cardShape } from '@editor/droplets/utils';
import { eventDate } from './utils';

export default function cardsEvent() {
  return {
    _id: false,
    type: 'droplet.cardsEvent',
    cards: _.times(
      2,
      cardShape({
        type: 'droplet.cardsEvent.cardItem',
        event: eventDate(),
      }),
    ),
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    firstDrop: false,
    activeCard: null,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-event/droplet.schema.js